<template>
  <div class="paymentapp">
        <public-title >
            打款申请列表
            <!-- <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回上一页</span> -->
        </public-title>
         <div class="bg-white load-area">
            <SearchCon ref="searchCon"   @getSearchCon="getSearchCon"/>
            <p v-if="total<=0" class="mt-3">当前没有数据</p>
            <div v-else class="el-tables">
                <template>
                <el-table
                    :data="list"
                    border
                    stripe
                    max-height="780"
                    style="width: 100%">
                    <!--表单内容-->
                    <el-table-column v-for="(item,index) in fundsForm" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center">
                    <!-- 自定义表头 -->
                    <template slot="header" slot-scope="scope">
                        <span>{{ scope.column.label }}</span>
                        <!-- <p v-if="item.total">{{ AdminDataLists.info.total[item.total] /100 | formatMoney}}</p> -->
                    </template>
                    <template slot-scope="scope">
                        <!--订单号-->
                        <div class="cursor-pointer pointers" :class="{'text-center':item.center}" v-if="item.pattern==='oid'" @click="goHotelDetail(scope.row)">{{ scope.row[item.prop]}}</div>
                        <!--时间-->
                        <div :class="{'text-center':item.center}" v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(5)}}</div>
                        <!--金额-->
                        <div :class="{'text-center':item.center}" v-else-if="item.pattern==='money'">{{ scope.row[item.prop]/100 | formatMoney}}<div class="price_pay" v-if="item.prop=='price_pay'&&scope.row.broker==1">(代订收款)</div></div>
                        <!--状态-->
                        <div class="red" :class="{'text-center':item.center}" v-else-if="item.pattern==='status'">{{isAdmin?'企业':''}}待处理</div>
                        <!--其他-->
                        <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
                    </template>
                    </el-table-column>
                    <!--操作按钮-->
                    <el-table-column
                    fixed="right"
                    header-align="center"
                    label="操作"
                    v-if="!isAdmin"
                    width="100">
                    <template slot-scope="scope">
                        <el-dropdown @command="handleCommand($event,scope.row)">
                            <el-button  class="el-dropdown-link text-link" type="text" size="small" style="margin: 0 auto; display: block;">查看<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  command="1">提交财务</el-dropdown-item>
                            <el-dropdown-item  command="2">驳回申请</el-dropdown-item>
                        </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <el-button @click="informUser(scope.row)" type="text" size="small" style="margin: 0 auto; display: block;">打款</el-button>
                        <el-button @click="revoke(scope.row)" type="text" size="small" style="margin: 0 auto; display: block;">{{userLoginMessage.id==scope.row.submit_uid?'撤销提交':'驳回'}}</el-button>
                        <el-button @click="financeprice(scope.row)"  type="text" size="small" style="margin: 0 auto; display: block;">修改手续费</el-button> -->
                        <!-- <el-dropdown-item  command="2" >撤销提交</el-dropdown-item>
                        <el-dropdown-item  command="3"  >修改手续费</el-dropdown-item> -->
                    </template>
                    </el-table-column>
                </el-table>
                <div class="el-pagination mt-4" >
                    <el-pagination background layout="total,prev, pager, next" 
                        :page-size="10"
                        :total="total" :current-page="Number(formData.page)"
                        @current-change="$GFUN.pageChange"/>
                </div>
                <!-- <el-pagination background layout="prev, pager, next, sizes" class="mt-4" :page-sizes="[10,15,20,30]" :page-size="Formdata.num" @size-change="handleSizeChange"
                            :total="AdminDataLists.total" :current-page="Number(Formdata.page)" @current-change="handleCurrentChange"/> -->
                </template>
            </div>
         </div>
        <el-dialog title="确认打款" :visible.sync="dialogFormVisible" width="20%" class="paymentist" :close-on-click-modal="false">
            <div class="d-center-start w-100 mb-3">
                <left-text leftText="订单号"/><span v-html="currentItem.oid"></span>
            </div>
            <div class="d-center-start w-100 mb-3">
                <left-text leftText="门店类型"/><span>{{currentItem.store_type | formatVar('StoreType')}}</span>
            </div>
            <div class="d-center-start w-100 mb-3" v-for="item in showDetailArr" :key="item.name">
                <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
            </div>
            <div class="d-center-start w-100 mb-3">
                <left-text leftText="待打款金额"/><span >{{currentItem.payment_pay/100 | formatMoney}}元</span>
            </div>
            <div class="d-center-start w-100 mb-3">
                <left-text leftText="手续费"/><span >{{currentItem.charge/100| formatMoney}}元</span>
            </div>
            <div class="d-center-start w-100 mb-3">
                <left-text leftText="实际打款金额"/><span class="red" >{{currentItem.fact_payment_pay/100| formatMoney}}元</span>
            </div>
            <div class="d-center-start w-100 mb-3">
                <left-text leftText="打款备注"/><span class="blues">{{currentItem.remark?currentItem.remark:'无'}}</span>
            </div>
            <!-- <div class=" name">订单号:{{ruleForm.oid}}</div>
            <div class=" name">所属酒店:{{hotel_title}}</div> -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" :disabled="isDisabled">确 定<span v-if="count>0">({{count}})</span></el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
 import SearchCon from './components/SearchCon.vue'
 import { mapGetters,mapActions,mapState} from 'vuex'
 import { debounce } from "lodash";
export default {
  name: 'PaymentApplication',
  components: {
    SearchCon,
  },
  props: {},
  data() {
    return {
        formData:{
            page:1,
            status:4,
            num:10,
        },
        list: [],
        total: 0,
        //搜索条件
        searchCon:{},
        loading: true,
        fundsForm:[
          {name:'订单号',prop:'oid',center:true,width:150,pattern:'oid'},
          {name:'门店名称',prop:'title',minWidth:200},
          {name:'银行账户',prop:'truename',minWidth:200},
          {name:'平台收款(元)',prop:'price_pay',center:true,width:150,pattern:'money'},
          {name:'手续费(元)',prop:'app_charge',center:true,width:150,pattern:'money'},
          {name:'付自由行(元)',prop:'offset_price_pay',center:true,width:150,pattern:'money'},
          {name:'订单金额(元)',prop:'payment_pay',center:true,width:150,pattern:'money'},
          {name:'酒店佣金(元)',prop:'charge',center:true,width:150,pattern:'money'},
          {name:'实际待打款金额(元)',prop:'fact_payment_pay',center:true,width:150,pattern:'money'},
          {name:'提交人',prop:'submit_name',center:true,width:120},
          {name:'提交时间',prop:'add_time',center:true,width:180,pattern:'time'},
          {name:'状态',prop:'status',center:true,width:120,pattern:'status'},
        ],
        //提交申请弹窗
        count:0,               //倒计时
        dialogFormVisible:false,
        currentItem:{},
        ruleForm:{
            pay_id:'',
            action:'',
        },
        isDisabled:true,
        showDetailArr:[
          {name:'银行卡所属',value:'truename'},{name:'开户银行',value:'bank_name'},{name:'支行名称',value:'branch'},{name:'银行卡号',value:'bank_card'}
        ],
    };
  },
  computed: {
        ...mapState(['newMessageInform']),
        ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
  },
  watch: {
        newMessageInform(newVal) {
            //收到通知刷新当前页面
        },
        '$route.query':{
            handler(toVal,fromVal){
                this.formData.page=toVal.page||1
                this.initial();
            },
            immediate:true
        }
  },
  created() {},
  mounted() {},
  methods: {
     ...mapActions(['POST_PaymentVerifyList','POST_VerifyFinance']),
        //初始化
        initial(){
            this.formData={...this.formData,...this.searchCon}
            this.getOrderList();
        },
        getOrderList: debounce(function() {
            this.loading = true;
            this.POST_PaymentVerifyList({
                data:this.$_Object.removeEmptyProps(this.formData),
                successFun:(res)=>{
                //如果是酒店待报价合并同一个订单按oid分组合并
                this.total = res.count;
                this.loading = false;
                this.list = res.list;

            }});
        },300),
        /*根据条件搜索订单*/
        getSearchCon(con) {
            this.searchCon = con||{};
            if (this.formData.page == 1) {this.initial()}
            else {
                this.$router.push({
                    name: this.$route.query.name,
                    query: {...this.formData, page: 1}
                })
            };
            
        },
        //点击操作按钮
        handleCommand(command,Itemize) {
            let htis = this;
            switch (command) {
            case '1':
                this.informUser(Itemize);
                break
            case '2':
                this.revoke(Itemize);
                break
            }
        },
        //点击打款
        informUser(item) {
            this.count = 3;
            this.ruleForm.pay_id = item.pay_id;
            this.ruleForm.action = 2;
            this.currentItem = item;
            this.dialogFormVisible = true;
            this.isDisabled = true;
            this.countDown()
        },
        //确认倒计时
        countDown() {
            setTimeout(() => {
                this.count--
                if (this.count > 0) {
                    this.countDown()
                } else {
                    this.isDisabled = false
                }
            }, 1000)
        },
        //撤销提交
        revoke(item){
            this._confirm('确定要驳回此打款信息么？',async () => {
                this.ruleForm.pay_id = item.pay_id;
                this.ruleForm.action = 1;
                this.submitForm();
            });
        },
        //打款
        submitForm: debounce(function(){
            this.dialogFormVisible = false;
            this.POST_VerifyFinance({
                data:this.ruleForm,
                successFun: () => {
                    this._alert('提交成功');
                    this.initial();
                }
            }); 
        },300),
  }
};
</script>

<style>
    .paymentapp .el-dropdown{
        display: flex;
        justify-content: center;
    }
</style>
